"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonFloatingVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    btnShadow: {
      boxShadow: "0 4px 10px rgba(0,0,0,.32)",
      "&:hover": {
        boxShadow: "0 4px 10px rgba(0,0,0,.32)"
      }
    }
  };
});
/**
 * **Buttons allow users to take actions, and make choices, with a single tap.**
 *
 * There are 4 variants: Primary, Secondary, Tertiary, Selected
 *
 */

var ButtonFloating = function ButtonFloating(_ref) {
  var action = _ref.action,
      icon = _ref.icon,
      variant = _ref.variant;
  var styles = useStyles();
  var themeProps = {
    "primary": {
      "variant": "contained",
      "color": "primary",
      "className": (0, _classnames.default)(_defineProperty({
        "MuiButton-containedRounded": true,
        "MuiButton-containedFloatIcon": true
      }, styles.btnShadow, true))
    },
    "secondary": {
      "variant": "contained",
      "className": (0, _classnames.default)(_defineProperty({
        "MuiButton-containedRounded": true,
        "MuiButton-containedFloatIcon": true
      }, styles.btnShadow, true))
    },
    "tertiary": {
      "variant": "contained",
      "className": (0, _classnames.default)(_defineProperty({
        "MuiButton-containedWhite": true,
        "MuiButton-containedRounded": true,
        "MuiButton-containedFloatIcon": true
      }, styles.btnShadow, true))
    },
    "selected": {
      "variant": "contained",
      "className": (0, _classnames.default)(_defineProperty({
        "MuiButton-containedRounded": true,
        "MuiButton-containedFloatIcon": true,
        "MuiButton-containedSelected": true
      }, styles.btnShadow, true))
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, themeProps[variant], {
    size: "large",
    onClick: function onClick(event) {
      return action && action(event);
    }
  }), /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: icon,
    color: variant === "tertiary" ? "red" : "white",
    size: "large"
  }));
};

ButtonFloating.propTypes = {
  /** The available colour variants of the button */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary', 'selected']),

  /** The icon key from SystemIcons for the button */
  icon: _propTypes.default.string.isRequired,

  /** Action that will called on click */
  action: _propTypes.default.func.isRequired
};
ButtonFloating.defaultProps = {
  variant: "primary"
};
var buttonFloatingVariants = ['primary', 'secondary', 'tertiary', 'selected'];
exports.buttonFloatingVariants = buttonFloatingVariants;
var _default = ButtonFloating;
exports.default = _default;